import { map } from 'rxjs/operators';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs'

import { LinkValidationModel } from '../../../shared/models/LinkValidation.model';
import { ConfigService } from '../../../config/config.service';
import { SessionService } from '../../../shared/services/session.service';
import { authenticateRequest } from '../model_temp/login.model';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type':  'application/json'
       })
     }
@Injectable()
export class ExtLoginService {
    baseUrl;
    constructor(private http:HttpClient, config: ConfigService,private sessionService: SessionService) {
       
      this.baseUrl = config.get('extApiUrl');
      if (!this.baseUrl) {
          config.load().then(() => {
              this.baseUrl = config.config['extApiUrl'];
          });
      }

     }   


     public getAuthToken(data: any, headers: HttpHeaders) {            
        return this.http.post(this.baseUrl + 'token', data, { headers: headers }).pipe(map(res => {
                     return res;
              }));
     }

      public setPasswordExpiry(data:string) {
          return this.http.post(this.baseUrl + 'api/UserManagement/PasswordExpiryReset',  JSON.stringify(data), httpOptions ).pipe(map(responsedata => {       
              let body = responsedata;
              return body || {};
              }));
          }

    

    // public isUserLoggedIn(): boolean {
    //     if (this.sessionService.getItem('id_token') !== 'Not-Set' && this.sessionService.getItem('isLoggedIn') === 'true') {
    //         return true;
    //     } else {
    //         return false;
    //     }
    // }

    // public getRoleBasedMenu(userId) {

    //     return this.http.get(this.baseUrl + 'api/Login/GetUserRoleModuleAccess/' + userId).map(responsedata => {
    //         var result = responsedata; // #viracor 
    //         return result || {};
    //     });
    // }
}